import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconHelpBook = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.1875 0H6.5625V5.625L4.6875 4.6875L2.8125 5.625V0C1.21875 0 0 1.21875 0 2.8125V12.1875C0 13.7812 1.21875 15 2.8125 15H12.1875C13.7812 15 15 13.7812 15 12.1875V8.4375V2.8125C15 1.21875 13.7812 0 12.1875 0ZM13.125 12.1875C13.125 12.75 12.75 13.125 12.1875 13.125H2.8125C2.25 13.125 1.875 12.75 1.875 12.1875C1.875 11.625 2.25 11.25 2.8125 11.25H12.1875C12.75 11.25 13.0312 11.1562 13.125 11.0625V12.1875Z",
		fill: "currentColor"
	})
});
export default SvgIconHelpBook;
